import React, { useEffect, useState } from 'react';
// @ts-ignore
import delay from 'lodash.delay';
import { LoaderContext, LoaderContextHolder } from './context/LoaderContext';
import { LoaderGif } from '@zooplus/ui-components';

class LoaderRequestTracker {
  private defaultTagName = '_';
  private tags = new Set();

  constructor() {
    this.reset();
  }

  reset() {
    this.tags.clear();
  }

  activate(tag = this.defaultTagName) {
    this.tags.add(tag);
  }

  deactivate(tag = this.defaultTagName) {
    this.tags.delete(tag);
  }

  hasActiveRequests(): boolean {
    return this.tags.size > 0;
  }

  toString() {
    const values = {
      tags: Array.from(this.tags.entries()),
      hasActiveRequests: this.hasActiveRequests(),
    };
    return JSON.stringify(values);
  }
}

const loaderRequestTracker = new LoaderRequestTracker();

const AppLoader: React.FC<any> = (props: any) => {
  const [isLoaderActive, setIsLoaderActive] = useState(true);
  const [isLoaderVisible, setIsLoaderVisible] = useState(isLoaderActive);

  const getIsLoaderActive = () => isLoaderActive;

  const requestLoaderShow = (tag?: string) => {
    loaderRequestTracker.activate(tag);
    setIsLoaderActive(loaderRequestTracker.hasActiveRequests());
  };
  const requestLoaderHide = (tag?: string) => {
    loaderRequestTracker.deactivate(tag);
    setIsLoaderActive(loaderRequestTracker.hasActiveRequests());
  };

  const loaderState = {
    isLoaderActive: getIsLoaderActive,
    requestLoaderShow,
    requestLoaderHide,
  } as LoaderContextHolder;

  // hide the loader after max. 5s
  useEffect(() => {
    setTimeout(() => {
      loaderRequestTracker.reset();
      setIsLoaderActive(loaderRequestTracker.hasActiveRequests());
    }, 5000);
  }, []);

  // TODO: it would be better to animate the loader instead of playing with the delay (which might have bad side-effects in React
  useEffect(() => {
    if (isLoaderActive) {
      setIsLoaderVisible(isLoaderActive);
    } else {
      delay(setIsLoaderVisible, 100, isLoaderActive);
    }
  }, [isLoaderActive]);

  return (
    <LoaderContext.Provider value={loaderState}>
      {isLoaderVisible && (
        <LoaderGif fullPage={props.position !== 'inner'} data-test="contactForm.loader" />
      )}
      {props.children}
    </LoaderContext.Provider>
  );
};

export default AppLoader;
